import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Header from "./components/Header";
import Footer from "./components/Footer";

import HomeScreen from "./screens/HomeScreen";
import BandsScreen from "./screens/BandsScreen";
import BandDetailScreen from "./screens/BandDetailsScreen";
import AboutScreen from "./screens/AboutScreen";
import ReleasesPage from "./screens/ReleasesPage";
import ArticlesScreen from "./screens/NewsScreen";
import ArticleDetailsScreen from "./screens/NewsDetailsScreen";
import PlaylistsScreen from "./screens/PlaylistsScreen";

// Local admin/editor screens
import AdminBandsScreen from "./admin-screens/AdminBandsScreen";

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Header />

      <Routes>
        <Route path="/" element={<HomeScreen />} />

        <Route path="/bands" element={<BandsScreen />} />
        <Route path="/bands/:slug" element={<BandDetailScreen />} />

        <Route path="/playlists" element={<PlaylistsScreen />} />

        <Route path="/about" element={<AboutScreen />} />

        <Route path="/releases" element={<ReleasesPage />} />

        <Route path="/news" element={<ArticlesScreen />} />
        <Route path="/news/:slug" element={<ArticleDetailsScreen />} />

        {/* LOCAL EDITOR */}
        <Route path="/admin-bands" element={<AdminBandsScreen />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;